export const switchQrCardImgAppend = (qrCardImg: any, uploadData: FormData) => {

  if (qrCardImg instanceof FileList && qrCardImg.length > 0) {
    uploadData.append("qr_card_img", qrCardImg[0], qrCardImg[0].name);
  } else {
    uploadData.append("qr_card_img", "");
  }
};